import clsx from "clsx";
import { createElement } from "react";
import classes from "./BaseContainer.module.scss";

type PropsType = {
  element?: keyof React.ReactHTML;
};

const BaseContainer = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & PropsType
) => {
  const { className, element = "div", ...rest } = props;

  return createElement(element, { className: clsx(classes.container, className), ...rest });
};

export default BaseContainer;
